'use client'
import React, { createContext, useState, useContext } from 'react'

interface MenuContextData {
  open: boolean
  toggle: (newValue?: boolean) => void
}

const MenuContext = createContext<MenuContextData>({} as MenuContextData)
export const MenuProvider = ({ children }: { children: React.ReactNode }) => {
  const [open, setOpen] = useState(false)
  const toggle = (newValue?: boolean) => {
    if (newValue) {
      setOpen(newValue)
      return
    }

    setOpen((o) => !o)
  }

  return (
    <MenuContext.Provider
      value={{
        open,
        toggle,
      }}
    >
      {children}
    </MenuContext.Provider>
  )
}

export function useMenu(): MenuContextData {
  const context = useContext(MenuContext)

  return context
}
